export default __webpack_public_path__ + "hero-next-52b2746b8b153994145ff08ec3229326.bundle.svg";